module.exports = __webpack_public_path__ + "media/images/icons/calendar-61313caf9aa11f0a4dec39e2aa3d3664.svg";